import {createFileRoute} from "@tanstack/react-router";
import {getWorkspaceDefinitionsMetadataWithCaching} from "~/utilities/fetchWorkspaceDefinitionsMetadata";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {RouteComponent} from "../-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/workspace-capabilities/",
)({
    loader: async ({context}) => {
        const workspaceDefinitionsMetadata = await getWorkspaceDefinitionsMetadataWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        });

        return {
            workspaceDefinitionsMetadata,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
